/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF
/* eslint react/destructuring-assignment: 0 */ // --> OFF

import React from "react";
import { useField, useFormikContext } from "formik";

import DropdownPR from "../../PrimeReact/DropdownPR";
import InputText from "../InputText";

export default function Dropdown(props) {
  const [field, meta] = useField(props);
  const { handleBlur } = useFormikContext();
  let placeholder = null;

  if (props?.inputMap) {
    placeholder = props.inputMap[field.value]
      ? props.inputMap[field.value]
      : "";
  }
  return (
    <div className="p-grid">
      <div className="p-col-12 p-md-6">
        <DropdownPR
          handleBlur={handleBlur}
          field={field}
          className="p-col-12 p-col-nogutter"
          {...props}
        />
      </div>

      {placeholder ? (
        <div className="p-col-12 p-md-6">
          <InputText
            name={props?.inputName}
            placeholder={placeholder}
            className="p-col-12"
          />
        </div>
      ) : null}

      {meta.touched && meta.error ? (
        <small className="p-invalid">{meta.error}</small>
      ) : null}
    </div>
  );
}
